module.exports = __webpack_public_path__ + "img/logo19.60646837.png";